<template>
    <div class="home-block-5">
        <ei-mask  :style="leftTopImg"></ei-mask>
        <ei-mask  :style="rightTopImg"></ei-mask>
        <ei-mask  :style="leftBottomImg"></ei-mask>
        <ei-mask  :style="rightBottomImg"></ei-mask>
    </div>
</template>

<script>
	import { queryHomeBlockInHomeAction } from '@/api/reception/home-api'
  import { isFailure } from '@/eiuov-utils/axios/response'

  export default {
		name: "EiHomeBlock5",
		data() {
			return {
				leftTopImg: '',
				rightTopImg: '',
				leftBottomImg: '',
				rightBottomImg: '',
        homeBlockList:[],
			}
		},
    created () {
      queryHomeBlockInHomeAction({ blockName: '首页模块5' }).then((res) => {
        if (isFailure(res)) return
        this.homeBlockList = res.data.list
      })
    },
		methods: {
			initHomeBlockList(list) {
				if (list.length === 0) return
				this.$set(this, "leftTopImg", this.getImage(list, '左上'))
				console.log('leftTopImg', this.leftTopImg)
				this.rightTopImg = this.getImage(list, '右上')
				this.leftBottomImg = this.getImage(list, '左下')
				this.rightBottomImg = this.getImage(list, '右下')
			},
			getImage(list, name) {
				if (list.length === 0) return '';
				for (let i = 0; i < list.length; i++) {
					if (list[i].blockName === name && list[i].picture !== null) {
						return list[i].picture.url
					}
				}
				return ''
			},
    },
	}
</script>

<style scoped lang="scss">
    .home-block-5 {
        margin: 60px auto;
        max-width: 1600px;
        min-width: 1600px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    * img,span,a,div{
      user-select: none;
      -webkit-user-drag:none;
    }
</style>
